import React,{useState, useEffect}  from "react";
import { getSolicitudesPorEstado, getResumenEquipos , getResumenCostoMaquina} from "../../services/Reportes.js";

import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
// components

import CardLineChart from "../../components/Cards/CardLineChart.js";
import CardBarChart from "../../components/Cards/CardBarChart.js";

import HeaderStats from "../../components/Headers/HeaderStats.js";

const DashboardN = () =>{
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('InicioAnno')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [estado, setEstado] = useState('ALL');
  const [tipoSolicitud, setTipoSolicitud] = useState('ALL');
  const [solicitudesT, setSolicitudesT] = useState(0);
  const [solicitudesF, setSolicitudesF] = useState(0);  // Aprobada
  const [solicitudesP, setSolicitudesP] = useState(0);  // Pendiente + En Proceso
  const [solicitudesR, setSolicitudesR] = useState(0); // Rechazada
  const [equiposT, setEquiposT] = useState(0); // Total Equipos Solicitados
  const [equiposA, setEquiposA] = useState(0); // Total Equipos Aprobados
  const [equiposP, setEquiposP] = useState(0); // Total Equipos Pendiente
  const [criticosT, setCriticosT] = useState(0); // Total Equipos Criticos Totales
  const [criticosP, setCriticosP] = useState(0); // Total Equipos Criticos Pendientes
  const [implementaT, setImplementaT] = useState(0); // Total Equipos Implementados Totales
  const [implementaP, setImplementaP] = useState(0); // Total Equipos Implementados Pendientes
  const [labelsDataC, setLabelsDataC] = useState([]);
  const [dataDataC, setDataDataC] = useState([]);
  const [labelsDataM, setLabelsDataM] = useState([]);
  const [dataDataM, setDataDataM] = useState([]);

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  const handleChangeTipoSolicitud = (e) =>{
    setTipoSolicitud( e.target.value );
  }

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const firstDayYear = new Date(today.getFullYear(), 0, 1);
    if(Como === 'InicioAnno') return firstDayYear;
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

    useEffect(()=>{
      const fetchData = async () => {
        const soliciData = await getSolicitudesPorEstado(selectedDate.toISOString(),selectedDateEnd.toISOString());
       
        // Obtener el Gran Total sumando todos los valores de 'total'
        let granTotal = 0;
        
        if (soliciData) {
          const solRecha = soliciData.find((item) => item.estado === 'Rechazada'); 
          let numDataR = solRecha ? solRecha.totalSolicitudes : 0;
          setSolicitudesR(numDataR);
          const solFinali = soliciData.find((item) => item.estado === 'Finalizada'); 
          let numDataF = solFinali ? solFinali.totalSolicitudes : 0;
          setSolicitudesF(numDataF);
          const solEnPro = soliciData.find((item) => item.estado === 'En Proceso'); 
          //const solPen = soliciData.find((item) => item.estado === 'Pendiente'); 
          let sumaDato = (solEnPro ? solEnPro.totalSolicitudes : 0) ; // (solPen ? solPen.totalSolicitudes : 0)  + 
          setSolicitudesP(sumaDato);
          granTotal = numDataR + numDataF + sumaDato;
        }
        setSolicitudesT(granTotal);

        const equiposData = await getResumenEquipos(selectedDate.toISOString(),selectedDateEnd.toISOString());

        if (equiposData){
          const sumaTotalCantidad = equiposData.reduce((accumulator, { totalCantidad }) => {
            return accumulator + (totalCantidad || 0); // Asegura que no sume undefined o null
          }, 0);
          setEquiposT(sumaTotalCantidad);
          const sumaAprobados = equiposData.reduce((accumulator, { estadoEquipo, totalCantidad }) => {
            return estadoEquipo?.trim().toLowerCase() === "aprobado" ? accumulator + (totalCantidad || 0) : accumulator;
          }, 0);
          setEquiposA(sumaAprobados);
          const sumaPendientes = equiposData.reduce((accumulator, { estadoEquipo, totalCantidad }) => {
            return estadoEquipo?.trim().toLowerCase()==="pendiente" ? accumulator + (totalCantidad || 0) : accumulator;
          }, 0);
          setEquiposP(sumaPendientes);

          const sumaCriticos = equiposData.reduce((accumulator, { esCritico, totalCantidad }) => {
            return esCritico?.trim().toLowerCase() === "si" ? accumulator + (totalCantidad || 0) : accumulator;
          }, 0);
          setCriticosT(sumaCriticos);

          const sumaCriticosP = equiposData.reduce((accumulator, { estadoEquipo, esCritico, totalCantidad }) => {
            return (esCritico?.trim().toLowerCase() === "si" && estadoEquipo?.trim().toLowerCase()==="pendiente" )  ? accumulator + (totalCantidad || 0) : accumulator;
          }, 0);
          setCriticosP(sumaCriticosP);

          const sumaImplementa = equiposData.reduce((accumulator, { estadoEquipo, totalCantidad }) => {
            return (estadoEquipo?.trim().toLowerCase()==="aprobado" )  ? accumulator + (totalCantidad || 0) : accumulator;
          }, 0);
          setImplementaT(sumaImplementa);

          const sumaImplementaP = equiposData.reduce((accumulator, { estadoEquipo, estadoImplementa, totalCantidad }) => {
            return (estadoEquipo?.trim().toLowerCase()==="aprobado" && estadoImplementa?.trim().toLowerCase()==="pendiente" )  ? accumulator + (totalCantidad || 0) : accumulator;
          }, 0);
          setImplementaP(sumaImplementaP);

          const equiposCentro = await getResumenCostoMaquina(selectedDate.toISOString(),selectedDateEnd.toISOString());

          const midataCentro = equiposCentro.reduce((acc, item) => {
            const { codigoCentro, totalCantidad } = item;
        
            if (!acc[codigoCentro]) {
              acc[codigoCentro] = {
                codigoCentro,
                totalCantidad: 0, // Inicializamos el total
              };
            }
        
            acc[codigoCentro].totalCantidad += totalCantidad;
            return acc;
          }, {});

        // Convertimos el objeto en un array
        const resultado = Object.values(midataCentro);

        // Extraemos los arreglos
        const labels = resultado.map(item => item.codigoCentro); // ["442", "XXX", ...]
        const data = resultado.map(item => item.totalCantidad);  // [5, 3, ...]

          setLabelsDataC(labels);
          setDataDataC(data);

          const midataMaquina = equiposCentro.reduce((acc, item) => {
            const { codigoMaquina, totalCantidad } = item;
        
            if (!acc[codigoMaquina]) {
              acc[codigoMaquina] = {
                codigoMaquina,
                totalCantidad: 0, // Inicializamos el total
              };
            }
        
            acc[codigoMaquina].totalCantidad += totalCantidad;
            return acc;
          }, {});

        // Convertimos el objeto en un array
        const resultadoM = Object.values(midataMaquina);

        // Extraemos los arreglos
        const labelsM = resultadoM.map(item => item.codigoMaquina); // ["442", "XXX", ...]
        const dataM = resultadoM.map(item => item.totalCantidad);  // [5, 3, ...]

          setLabelsDataM(labelsM);
          setDataDataM(dataM);

        }

      };
      fetchData();
    },[selectedDate,selectedDateEnd]); 


  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  return (
    <>
<div className=" mx-4 lg:mx-12 mt-4">
<div className=" dark:bg-secondary-dark-bg p-4 rounded-2xl shadow mt-4">
  <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    
    {/* Desde */}
    <div className="flex flex-col">
      <label className="text-xs font-semibold mb-1 whitespace-nowrap">Desde</label>
      <SeleccionaFecha
        selectedDate={selectedDate}
        handleDateChange={handleDateChange}
      />
    </div>

    {/* Hasta */}
    <div className="flex flex-col">
      <label className="text-xs font-semibold mb-1 whitespace-nowrap">Hasta</label>
      <SeleccionaFecha
        selectedDate={selectedDateEnd}
        handleDateChange={handleDateChangeEnd}
      />
    </div>

    {/* Tipo */}
    <div className="flex flex-col">
      <label className="text-xs font-semibold mb-1 whitespace-nowrap">Tipo</label>
      <select
        className="text-xs border border-gray-300 p-2 rounded"
        name="tipoSolicitud"
        value={tipoSolicitud}
        onChange={handleChangeTipoSolicitud}
      >
        <option value="ALL">Todos</option>
        <option value="Entrada">Entrada</option>
        <option value="Salida">Salida</option>
        <option value="Adicional">Adicional</option>
        <option value="Reemplazo">Reemplazo</option>
      </select>
    </div>

    {/* Estado */}
    <div className="flex flex-col">
      <label className="text-xs font-semibold mb-1 whitespace-nowrap">Estado</label>
      <select
        className="text-xs border border-gray-300 p-2 rounded"
        name="estado"
        value={estado}
        onChange={handleChangeEstado}
      >
        <option value="ALL">Todos</option>
        <option value="Pendiente">Pendiente</option>
        <option value="En Proceso">En Proceso</option>
        <option value="Aprobada">Aprobada</option>
        <option value="Rechazada">Rechazada</option>
      </select>
    </div>
  </div>
</div>


      <HeaderStats 
        solicitudesT={solicitudesT} 
        solicitudesP={solicitudesP}
        equiposT={equiposT}
        equiposP={equiposP} 
        criticosT={criticosT}
        criticosP={criticosP}
        implementaT={implementaT}
        implementaP={implementaP}
      />
      <div className="px-4 md:px-10 mx-auto w-full -m-24">

        <div className="flex flex-wrap">
          <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
            <CardLineChart labelsData={labelsDataC} dataData={dataDataC} />
          </div>
          <div className="w-full xl:w-4/12 px-4">
            <CardBarChart  labelsData={labelsDataM} dataData={dataDataM} />
          </div>
        </div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
           {/* <CardPageVisits /> */} 
          </div>
          <div className="w-full xl:w-4/12 px-4">
            {/*<CardSocialTraffic />*/}
          </div>
        </div>
      </div>
</div>
    </>
  );
}

export default DashboardN;